import React, { useState, useEffect } from 'react';
import PageHeader from '../../../../components/PageHeader/PageHeader';
import ColEdit from '../../../../components/ColEdit/ColEdit';
import GridDefaultShimmer from '../../../../components/GridDefaultShimmer/GridDefaultShimmer';
import HRDeductionNew from './New/HRDeductionNew';
import { API } from '../../../../API/API';
import { useContext } from 'react';
import { UserContext } from '../../../../context/UserContext';
import { isEdit } from '../../../../SharedFunc/User';

const HRDeduction = (props) => {

    const { userInfo } = useContext(UserContext);

    const [data, setData] = useState([]);
    const [oData, setOData] = useState([]);
    const [showNew, setShowNew] = useState(false);
    const [deductionid, setDeductionId] = useState();

    const getData = async () => {
        let tData = [];
        setLoading(true);
        await API.get('/api/payroll/deduction/getdeductionlistfull').then(response => {
            if (response.status == 200 && response.data.retType == 0) {
                if (response.data?.retData?.length > 0) {
                    tData = response.data.retData;
                }
            }
        });
        setLoading(false);
        setData(tData);
        setOData(tData);
    }

    useEffect(() => {
        getData();
    }, []);

    const [columns] = useState([{
        name: 'Суутгал нэр',
        fieldName: 'name',
        onRender: (item) => {
            if (edit) {
                return (
                    <ColEdit onClick={() => onEdit(item.deductionid)}>{item.name}</ColEdit>
                );
            } else {
                return item.name;
            }
        }
    }, {
        name: 'Эхлэх огноо',
        fieldName: 'begindate'
    }, {
        name: 'Дуусах огноо',
        fieldName: 'enddate'
    }]);

    const [loading, setLoading] = useState(false);
    const [edit] = useState(isEdit(userInfo?.accesstoken, ["HR", "MANAGER"]));

    const onNew = () => {
        setDeductionId();
        setShowNew(true);
    }

    const onEdit = (p_id) => {
        setDeductionId(p_id);
        setShowNew(true);
    }

    const onDismiss = () => {
        setDeductionId();
        setShowNew(false);
    }

    const afterSave = () => {
        getData();
    }

    const onSearch = (p_data) => {
        setData(p_data);
    }

    return (
        <div>
            <PageHeader
                title={'Суутгал (' + data?.length + ')'}
                buttonTitle={edit ? 'Суутгал нэмэх' : null}
                onButtonClick={onNew}
                columns={columns}
                data={oData}
                filteredData={data}
                onSearch={onSearch}
                loading={loading}
            />
            <GridDefaultShimmer
                setKey='deductionid'
                loading={loading}
                columns={columns}
                data={data}
            />
            <HRDeductionNew
                deductionid={deductionid}
                isOpen={showNew}
                onDismiss={onDismiss}
                afterSave={afterSave}
            />
        </div>
    );
}

export default HRDeduction;